import { createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-76ac9e07"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "modal_container" }
const _hoisted_3 = { class: "modal_wrapper" }
const _hoisted_4 = { class: "modal_background" }
const _hoisted_5 = ["data-url"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "modal_wrapper_text" }, "쿠폰 다운로드 완료!", -1 /* HOISTED */))
const _hoisted_7 = { class: "modal_wrapper_button" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "modal_wrapper_button_text" }, "확인", -1 /* HOISTED */))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "main" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "background_main_img" }),
  /*#__PURE__*/_createCommentVNode(" <div class=\"background_main_img_02\"></div> "),
  /*#__PURE__*/_createCommentVNode(" <div class=\"background_main_img\">\n        <div class=\"tudal\"></div>\n        <div class=\"benefit_container\">\n          <div class=\"benefit_box\">\n            <div class=\"title\">\n              <div class=\"sub\">새로운 한 해를 위해 준비한 혜택</div>\n              지금 바로 만나보세요!\n              <h5 class=\"event_date\">※ 프로모션은 상시 종료될 수 있습니다.</h5>\n            </div>\n            <div class=\"benefit\">\n              <div class=\"benefit_text_wrap\">\n                <div class=\"benefit_label\">혜택 1</div>\n                <div class=\"benefit_text\">\n                  할인 쿠폰팩 총\n                  <span class=\"emphasis_text\">45만원</span>\n                </div>\n              </div>\n              <div class=\"benefit_text_wrap\">\n                <div class=\"benefit_label\">혜택 2</div>\n                <div class=\"benefit_text\">\n                  수강권 최대\n                  <span class=\"emphasis_text\">72%</span>\n                  할인\n                </div>\n              </div>\n              <div class=\"benefit_text_wrap end_text\">\n                <div class=\"benefit_label\">혜택 3</div>\n                <div class=\"benefit_text\">\n                  원어민회화 수강권 구매 시\n                  <br />\n                  <span class=\"emphasis_text\">AI 학습 무료 제공</span>\n                </div>\n              </div>\n            </div>\n\n            <button\n              class=\"button\"\n              :class=\"[{ downloadAllAfter: !hasCouponDownloadAll || isAllCouponDownloaded }]\"\n              :disabled=\"!hasCouponDownloadAll || isAllCouponDownloaded\"\n              @click=\"postCouponDownloadAll()\"\n            >\n              쿠폰팩 모두 받기\n            </button>\n            <Loading :isLoading=\"isAllCouponDownloaded || isCouponDownloaded\" />\n          </div>\n        </div>\n        <div class=\"tudal_2\"></div>\n      </div> ")
], -1 /* HOISTED */))
const _hoisted_11 = { class: "course_container" }
const _hoisted_12 = {
  class: "coupon__container",
  id: "togo1"
}
const _hoisted_13 = { class: "default_inner" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "혜택 1", -1 /* HOISTED */))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "benefit__desc",
  style: {"margin-bottom":"32px"}
}, [
  /*#__PURE__*/_createElementVNode("h5", null, "3일간 열리는 타이머 쿠폰"),
  /*#__PURE__*/_createElementVNode("h3", null, "늦을수록 할인은 작아집니다.")
], -1 /* HOISTED */))
const _hoisted_16 = { class: "coupon__list" }
const _hoisted_17 = {
  key: 0,
  class: "coupon__wrapper"
}
const _hoisted_18 = { class: "coupon__wrapper_left" }
const _hoisted_19 = { class: "coupon__wrapper_top_text" }
const _hoisted_20 = { class: "coupon__wrapper_bottom_text" }
const _hoisted_21 = { class: "coupon__wrapper_right" }
const _hoisted_22 = { class: "coupon__wrapper_right_check" }
const _hoisted_23 = ["data-url"]
const _hoisted_24 = {
  key: 1,
  class: "coupon__wrapper__1"
}
const _hoisted_25 = { class: "coupon__wrapper_left" }
const _hoisted_26 = { class: "coupon__wrapper_top_text_1" }
const _hoisted_27 = { class: "coupon__wrapper_bottom_text_1" }
const _hoisted_28 = { class: "coupon__wrapper_right_1" }
const _hoisted_29 = { class: "coupon__wrapper_right_check" }
const _hoisted_30 = ["data-url"]
const _hoisted_31 = {
  key: 2,
  class: "coupon__wrapper__2"
}
const _hoisted_32 = { class: "coupon__wrapper_left" }
const _hoisted_33 = { class: "coupon__wrapper_top_text" }
const _hoisted_34 = { class: "coupon__wrapper_bottom_text_2" }
const _hoisted_35 = { class: "coupon__wrapper_right_2" }
const _hoisted_36 = { class: "coupon__wrapper_right_check" }
const _hoisted_37 = ["data-url"]
const _hoisted_38 = /*#__PURE__*/_createStaticVNode("<div class=\"coupon__info\" data-v-76ac9e07><div class=\"inner\" data-v-76ac9e07><p class=\"title\" data-v-76ac9e07>쿠폰 유의 사항</p><ul class=\"desc\" data-v-76ac9e07><li class=\"list__item__text\" data-v-76ac9e07>쿠폰 다운로드 후 사용 가능</li><li class=\"list__item__text\" data-v-76ac9e07>365올패스(정기권 제외), 작심패키지 구매 시 적용 가능</li><li class=\"list__item__text\" data-v-76ac9e07>더하기 쿠폰 중복 사용 가능</li><li class=\"list__item__text\" data-v-76ac9e07>365올패스 재구매 할인 적용 시에도 쿠폰 사용 가능</li></ul></div></div>", 1)
const _hoisted_39 = {
  class: "course__info",
  style: {"padding-bottom":"40px","padding-top":"40px"}
}
const _hoisted_40 = {
  class: "inner",
  id: "togo2"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "혜택 2", -1 /* HOISTED */))
const _hoisted_42 = {
  key: 0,
  class: "benefit__desc_1"
}
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "benefit__desc_1_text" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "재구매 고객 전용 특별 혜택"),
  /*#__PURE__*/_createElementVNode("h3", null, [
    /*#__PURE__*/_createTextVNode(" 수강권 구매 시 "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 100,000 포인트 증정! ")
  ])
], -1 /* HOISTED */))
const _hoisted_44 = ["data-url"]
const _hoisted_45 = {
  key: 1,
  class: "benefit__desc_1"
}
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "튜달이 쿠션 받아가세요!", -1 /* HOISTED */))
const _hoisted_47 = ["data-url"]
const _hoisted_48 = /*#__PURE__*/_createStaticVNode("<div class=\"coupon__info\" data-v-76ac9e07><div class=\"inner\" data-v-76ac9e07><p class=\"title\" data-v-76ac9e07>이벤트 유의사항</p><ul class=\"desc\" data-v-76ac9e07><li class=\"list__item__text\" data-v-76ac9e07>굿즈 구매 시 사용 가능한 포인트 형태로 지급됩니다.</li><li class=\"list__item__text\" data-v-76ac9e07>포인트는 지급일로부터 1개월간 사용 가능합니다.</li><li class=\"list__item__text\" data-v-76ac9e07>포인트는 영업일 기준 10일 이내로 지급됩니다.</li><li class=\"list__item__text\" data-v-76ac9e07>MY &gt; 포인트&amp;포인트몰에서 구매 가능</li></ul></div></div>", 1)
const _hoisted_49 = {
  class: "course__info",
  style: {"padding-bottom":"40px","padding-top":"40px"}
}
const _hoisted_50 = {
  class: "inner",
  id: "togo3"
}
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "혜택 3", -1 /* HOISTED */))
const _hoisted_52 = {
  key: 0,
  class: "benefit__desc"
}
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Time’s up! 타이머가 끝났어도", -1 /* HOISTED */))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "AI 수강권은 100% 증정!", -1 /* HOISTED */))
const _hoisted_55 = ["data-url"]
const _hoisted_56 = {
  key: 1,
  class: "benefit__desc"
}
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Tick Tock, 3일 내로 구매 시", -1 /* HOISTED */))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "AI 수강권 100% 증정!", -1 /* HOISTED */))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "※ 원어민 회화 수강권 구매 시, 적용됩니다.", -1 /* HOISTED */))
const _hoisted_60 = ["data-url"]
const _hoisted_61 = { class: "focus-certificate" }
const _hoisted_62 = { class: "certificate-sector" }
const _hoisted_63 = { class: "promotion-certificate" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "heading" }, "수강증 상시 발급 가능", -1 /* HOISTED */))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "description" }, "수강증, 출석확인증, 영수증 상시 발급 가능", -1 /* HOISTED */))
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "certificate__tip",
  style: {"margin-top":"10px","max-width":"312px"}
}, [
  /*#__PURE__*/_createTextVNode(" 직장인들을 위한 SPEC UP! "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 사내 교육지원비로 알뜰하게! ")
], -1 /* HOISTED */))
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "증빙서류 샘플 상세보기", -1 /* HOISTED */))
const _hoisted_68 = [
  _hoisted_67
]
const _hoisted_69 = /*#__PURE__*/_createStaticVNode("<div class=\"certificate-notice-sector\" data-v-76ac9e07><div style=\"margin:0 24px;\" data-v-76ac9e07><div class=\"promotion-guide\" data-v-76ac9e07><h2 class=\"heading\" data-v-76ac9e07>증빙 서류 발급 안내</h2><ul class=\"guide__list\" data-v-76ac9e07><li class=\"list__item\" data-v-76ac9e07> 수강증, 출석 확인증, 영수증은 링고라 앱 메인 화면 우측 하단 [마이링고라 &gt; 고객센터 &gt; 증빙 서류 발급 메뉴]에서 신청 가능합니다. </li><li class=\"list__item\" data-v-76ac9e07>정해진 학습 기간 내에 수업을 진행해야만 출석으로 인정합니다.</li><li class=\"list__item\" data-v-76ac9e07>증빙서류의 경우 내용(수강권명, 금액)등은 임의 수정이 불가합니다.</li><li class=\"list__item\" data-v-76ac9e07> 발급 신청 시 입력한 이메일 주소로 자동 발급됩니다.(기타 문의사항은 [고객센터 &gt; 1:1 채팅 문의]로 연락 주시기 바랍니다.) </li></ul></div></div></div>", 1)
const _hoisted_70 = {
  key: 0,
  class: "common-modal common-modal--dimmed",
  id: "modalCertificateClose",
  style: {"display":"block"}
}
const _hoisted_71 = { class: "common-modal__modal modal__certificate" }
const _hoisted_72 = /*#__PURE__*/_createStaticVNode("<div class=\"common-modal__content\" data-v-76ac9e07><h1 class=\"heading\" data-v-76ac9e07>증빙서류 샘플</h1><p class=\"description\" data-v-76ac9e07> 수강증, 출석확인증, 영수증 상시 발급 가능 <br data-v-76ac9e07> 연 수강권의 경우 매월 수강권 발급이 가능합니다. </p><ul class=\"list\" data-v-76ac9e07><li class=\"list__item\" data-v-76ac9e07><img width=\"270\" src=\"//res.tutoring.co.kr/res/images/evt/com/receipt_img01.png\" alt=\"\" data-v-76ac9e07> - 수강증 증빙서류 샘플 - </li><li class=\"list__item\" data-v-76ac9e07><img width=\"270\" src=\"//res.tutoring.co.kr/res/images/evt/com/receipt_img02.png\" alt=\"\" data-v-76ac9e07> - 출석 확인증 증빙서류 샘플 - </li><li class=\"list__item\" data-v-76ac9e07><img width=\"270\" src=\"//res.tutoring.co.kr/res/images/evt/com/receipt_img03.png\" alt=\"\" data-v-76ac9e07> - 영수증 증빙서류 샘플 - </li></ul></div>", 1)
const _hoisted_73 = /*#__PURE__*/_createStaticVNode("<section class=\"promotion-notice\" data-v-76ac9e07><div class=\"notice__item\" style=\"padding:0;\" data-v-76ac9e07><div class=\"contents-center\" data-v-76ac9e07><div class=\"promotion_contents\" data-v-76ac9e07><div class=\"content\" data-v-76ac9e07><div class=\"title\" style=\"margin-bottom:8px;\" data-v-76ac9e07>[이벤트 유의 사항 및 쿠폰 사용 안내]</div><ul class=\"content__list\" data-v-76ac9e07><li class=\"list__item\" data-v-76ac9e07> 본 이벤트는 당사 사정에 따라 예고없이 일정이 변경되거나 이벤트가 중단될 수 있습니다. </li><li class=\"list__item\" data-v-76ac9e07><strong data-v-76ac9e07>본 이벤트 쿠폰은 프로모션 페이지 접속 시 자동으로 다운로드됩니다.</strong></li><li class=\"list__item\" data-v-76ac9e07>다운로드 완료된 쿠폰은 [마이링고라 &gt; 나의 쿠폰]에서 확인하실 수 있습니다.</li><li class=\"list__item\" data-v-76ac9e07>각 쿠폰은 쿠폰별 정해진 사용 기한 내에 사용하실 수 있습니다.</li><li class=\"list__item\" data-v-76ac9e07> 구매하시는 수강권의 사용 방법 및 환불 정책은 각 수강권의 유의사항을 확인해주시기 바랍니다. </li></ul></div></div></div></div></section>", 1)
const _hoisted_74 = {
  class: "challenge-cta is-info",
  id: "challengeCta"
}
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dim" }, null, -1 /* HOISTED */))
const _hoisted_76 = { class: "challenge-cta__wrap" }
const _hoisted_77 = { class: "wrapper" }
const _hoisted_78 = { class: "btnwrap" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "btnText" }, "지금 바로 혜택 받기", -1 /* HOISTED */))
const _hoisted_80 = [
  _hoisted_79
]
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "btnText" }, "지금 바로 혜택 받기", -1 /* HOISTED */))
const _hoisted_82 = [
  _hoisted_81
]
const _hoisted_83 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppNav = _resolveComponent("AppNav")!
  const _component_Loading = _resolveComponent("Loading")!
  const _component_PopupToast = _resolveComponent("PopupToast")!
  const _directive_img_lazy_loading = _resolveDirective("img-lazy-loading")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode(" app nav "),
    ($options.appView)
      ? (_openBlock(), _createBlock(_component_AppNav, { key: 0 }, {
          default: _withCtx(() => [
            _createTextVNode("링고라 프로모션")
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true),
    (!$data.isAllCouponDownload)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _withDirectives(_createElementVNode("img", {
                  "data-url": $data.imgUrls.ticktock_modal,
                  class: "modal_background_img"
                }, null, 8 /* PROPS */, _hoisted_5), [
                  [_directive_img_lazy_loading]
                ]),
                _hoisted_6,
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("button", {
                    class: "modal_wrapper_button_button",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.closeModal()))
                  }, _hoisted_9)
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", {
      class: "promotion",
      style: _normalizeStyle({ paddingTop: $options.appPadding, paddingBottom: $options.appBottom })
    }, [
      _createCommentVNode(" <section class=\"promotion-banner\">\n      <div class=\"wrapper\">\n        <div class=\"badge\">추가 혜택</div>\n        <div class=\"explain-wrap\">\n          <h5 class=\"title\">15만원 이상 결제 시 무이자 할부 최대 12개월 지원 (결제액별 상이)</h5>\n          <span class=\"sub\">무이자 할부는 1월 31일까지만 제공됩니다.</span>\n        </div>\n      </div>\n    </section> "),
      _createCommentVNode(" tutoring-festival "),
      _hoisted_10,
      _createElementVNode("section", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_Loading, {
            isLoading: $data.isAllCouponDownloaded || $data.isCouponDownloaded || $data.isGetCouponLoading
          }, null, 8 /* PROPS */, ["isLoading"]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.promotionData?.coupon?.data?.coupons, (coupon, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "coupon__wrapper_container"
                }, [
                  (
                  ['0', '1'].includes($data.countDown[index]?.[0]) ||
                  ($data.countDown[index]?.[0] === '2' && ['0', '1', '2', '3'].includes($data.countDown[index]?.[1]))
                )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("span", _hoisted_19, _toDisplayString(coupon.dc_rate) + "%", 1 /* TEXT */),
                          _createElementVNode("span", _hoisted_20, _toDisplayString($data.countDown[index]) + " 남음", 1 /* TEXT */)
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("div", _hoisted_22, [
                            _withDirectives(_createElementVNode("img", {
                              "data-url": $data.imgUrls.ticktock_02_check,
                              class: "ticktock_02_check"
                            }, null, 8 /* PROPS */, _hoisted_23), [
                              [_directive_img_lazy_loading]
                            ])
                          ])
                        ])
                      ]))
                    : ($data.countDown[index] === '사용 기간 종료')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                          _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("span", _hoisted_26, _toDisplayString(coupon.dc_rate) + "%", 1 /* TEXT */),
                            _createElementVNode("span", _hoisted_27, _toDisplayString($data.countDown[index]), 1 /* TEXT */)
                          ]),
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("div", _hoisted_29, [
                              _withDirectives(_createElementVNode("img", {
                                "data-url": $data.imgUrls.ticktock_02_check,
                                class: "ticktock_02_check"
                              }, null, 8 /* PROPS */, _hoisted_30), [
                                [_directive_img_lazy_loading]
                              ])
                            ])
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_31, [
                          _createElementVNode("div", _hoisted_32, [
                            _createElementVNode("span", _hoisted_33, _toDisplayString(coupon.dc_rate) + "%", 1 /* TEXT */),
                            _createElementVNode("span", _hoisted_34, _toDisplayString($data.countDown[index]) + " 남음", 1 /* TEXT */)
                          ]),
                          _createElementVNode("div", _hoisted_35, [
                            _createElementVNode("div", _hoisted_36, [
                              _withDirectives(_createElementVNode("img", {
                                "data-url": $data.imgUrls.ticktock_02_check,
                                class: "ticktock_02_check"
                              }, null, 8 /* PROPS */, _hoisted_37), [
                                [_directive_img_lazy_loading]
                              ])
                            ])
                          ])
                        ]))
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            _createCommentVNode(" 나중에 goToApply로 변경  "),
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($options.goToApply && $options.goToApply(...args))),
              class: "downloadAllAfter"
            }, "쿠폰 사용하러 가기")
          ])
        ]),
        _hoisted_38,
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("div", _hoisted_40, [
            _hoisted_41,
            ($data.paid_total_cnt !== '0')
              ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                  _hoisted_43,
                  _withDirectives(_createElementVNode("img", {
                    "data-url": $data.imgUrls.ticktock_02_repurchase,
                    class: "ticktock_02_repurchase"
                  }, null, 8 /* PROPS */, _hoisted_44), [
                    [_directive_img_lazy_loading]
                  ]),
                  _createElementVNode("button", {
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($options.goToApply && $options.goToApply(...args))),
                    type: "button",
                    class: "go_ticket"
                  }, "포인트 받으러 가기")
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_45, [
                  _hoisted_46,
                  _withDirectives(_createElementVNode("img", {
                    "data-url": $data.imgUrls.ticktock_02,
                    class: "ticktock_02"
                  }, null, 8 /* PROPS */, _hoisted_47), [
                    [_directive_img_lazy_loading]
                  ]),
                  _createElementVNode("button", {
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($options.goToApply && $options.goToApply(...args))),
                    type: "button",
                    class: "go_ticket"
                  }, "튜달이 쿠션 받으러 가기")
                ])),
            _createCommentVNode(" <img v-img-lazy-loading :data-url=\"imgUrls.ticktock_02_repurchase\" class=\"ticktock_02_repurchase\" /> "),
            _createCommentVNode(" <div class=\"benefit__live\" style=\"margin-bottom: 16px\">\n            <h3>AI 수강권은 살아있다!</h3>\n            <h6>\n              원어민 회화 수강권 구매 시,\n              <br />\n              AI 학습 100% 무료 제공\n            </h6>\n          </div>\n          <img v-img-lazy-loading :data-url=\"imgUrls.festival_02_end2\" class=\"festival_02\" />\n          <button @click=\"goToApply\" type=\"button\" class=\"go_ticket\">수강권 둘러보기</button> ")
          ])
        ]),
        _hoisted_48,
        _createElementVNode("div", _hoisted_49, [
          _createElementVNode("div", _hoisted_50, [
            _hoisted_51,
            ($options.isAllExpired)
              ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                  _hoisted_53,
                  _hoisted_54,
                  _withDirectives(_createElementVNode("img", {
                    "data-url": $data.imgUrls.festival_02_end2,
                    class: "festival_02"
                  }, null, 8 /* PROPS */, _hoisted_55), [
                    [_directive_img_lazy_loading]
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_56, [
                  _hoisted_57,
                  _hoisted_58,
                  _hoisted_59,
                  _withDirectives(_createElementVNode("img", {
                    "data-url": $data.imgUrls.festival_02_end2,
                    class: "festival_02"
                  }, null, 8 /* PROPS */, _hoisted_60), [
                    [_directive_img_lazy_loading]
                  ])
                ])),
            _createElementVNode("button", {
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($options.goToApply && $options.goToApply(...args))),
              type: "button",
              class: "go_ticket"
            }, "수강권 둘러보기")
          ])
        ])
      ]),
      _createCommentVNode(" 수강증 발급 안내 "),
      _createElementVNode("section", _hoisted_61, [
        _createElementVNode("div", _hoisted_62, [
          _createElementVNode("div", _hoisted_63, [
            _hoisted_64,
            _hoisted_65,
            _hoisted_66,
            _createElementVNode("button", {
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($options.openSample && $options.openSample(...args))),
              type: "button",
              class: "sample_btn",
              style: {"margin-top":"10px"}
            }, _hoisted_68)
          ])
        ]),
        _hoisted_69
      ]),
      _createCommentVNode(" 증명서류 샘플 상세보기 클릭시 나오는 부분 "),
      ($data.isSampleClicked)
        ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_71, [
              _hoisted_72,
              _createElementVNode("button", {
                type: "button",
                class: "modal__certificate__close",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => ($options.openSample && $options.openSample(...args)))
              }, "닫기")
            ])), [
              [_directive_click_outside, $options.openSample]
            ])
          ]))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" 하단 유의 사항  "),
      _hoisted_73,
      _createElementVNode("section", _hoisted_74, [
        _createCommentVNode(" l-select 에 is-on 넣을때 얘도 같이 is-on 넣어주세요  "),
        _hoisted_75,
        _createElementVNode("div", _hoisted_76, [
          _createElementVNode("div", _hoisted_77, [
            _createCommentVNode(" <div class=\"timer\" v-if=\"timestampEnd >= nowDate\">            \n            <CountDown :timestampEnd=\"timestampEnd\">\n              <template v-slot:default=\"slotProps\">\n                <div class=\"remain\">\n                  <div class=\"heading-wrapper\">\n                    <h2 class=\"heading\">남은 시간</h2>\n                    <span class=\"date\" v-if=\"!isDueDateEnd(timestampFinal)\">\n                      D -&nbsp;\n                      <span id=\"day1\">{{ slotProps.days1 === 0 ? '' : slotProps.days1 }}</span>\n                      <span id=\"day2\">{{ slotProps.days2 }}</span>\n                    </span>\n                    <span class=\"date\" v-else>\n                      <span id=\"day1\">오늘 마감</span>\n                    </span>\n                  </div>\n                  <div class=\"time\" :class=\"{ 'text-red': slotProps.days2 === 0 }\">\n                    <span>\n                      <span id=\"hour1\">{{ slotProps.hours1 }}</span>\n                      <span id=\"hour2\">{{ slotProps.hours2 }}</span>\n                    </span>\n                    :\n                    <span>\n                      <span id=\"minute1\">{{ slotProps.minutes1 }}</span>\n                      <span id=\"minute2\">{{ slotProps.minutes2 }}</span>\n                    </span>\n                    :\n                    <span>\n                      <span id=\"second1\">{{ slotProps.seconds1 }}</span>\n                      <span id=\"second2\">{{ slotProps.seconds2 }}</span>\n                    </span>\n                    :\n                    <span class=\"milliseconds-wrapper\">\n                      <span id=\"milliseconds1\">{{ slotProps.milliseconds1 }}</span>\n                      <span id=\"milliseconds2\">{{ slotProps.milliseconds2 }}</span>\n                    </span>\n                  </div>\n                </div>\n              </template>\n            </CountDown>\n          </div> "),
            _createElementVNode("div", _hoisted_78, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => ($options.goToApply && $options.goToApply(...args))),
                class: "cta__button cta__button pc-layer pc goToPay"
              }, _hoisted_80),
              _createElementVNode("button", {
                type: "button",
                class: "cta__mobile cta__button tamo-layer tablet-mobile",
                "data-status": "N",
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => ($options.goToApply && $options.goToApply(...args)))
              }, _hoisted_82)
            ])
          ])
        ])
      ]),
      _createVNode(_component_PopupToast, { isPopup: $data.isPopup }, {
        default: _withCtx(() => [
          _createElementVNode("p", { innerHTML: $data.cuponPopupMessage }, null, 8 /* PROPS */, _hoisted_83)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["isPopup"])
    ], 4 /* STYLE */)
  ], 64 /* STABLE_FRAGMENT */))
}